import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAuth } from './AuthContext';
import { cognitoHelpers } from './cognito';

export function AuthCallback() {
  const navigate = useNavigate();
  const { setTokens, isAuthenticated } = useAuth();
  const [exchangeSuccess, setExchangeSuccess] = useState(false);
  // Use a ref to prevent the code exchange from running twice in Strict Mode
  const processingRef = useRef(false);

  // Run code exchange once on mount
  useEffect(() => {
    if (processingRef.current) return;

    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const error = params.get('error');

      if (error) {
        navigate(`/login?error=${error}`, { replace: true });
        return;
      }

      if (!code) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        processingRef.current = true;

        const tokens = await cognitoHelpers.exchangeCodeForTokens(code);
        setTokens(tokens);
        setExchangeSuccess(true);
      } catch (err) {
        console.error('Failed to exchange code:', err);
        processingRef.current = false;
        navigate('/login?error=token_exchange_failed', { replace: true });
      }
    };

    handleCallback();
  }, [navigate, setTokens]);

  // Navigate only after auth state has committed (next render has isAuthenticated true)
  useEffect(() => {
    if (exchangeSuccess && isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [exchangeSuccess, isAuthenticated, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="h6">Finalizing your session...</Typography>
    </Box>
  );
}